import React, { useContext } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import Parser from 'html-react-parser';
import { RegistrationContext } from './RegistrationContainer';
import { sendVerificationCode } from '../../api/registration';

const BeforeYouStart = () => {
  const { formData, setFormData, error, setError, handleChange, setActiveStep, isValidEmail } =
    useContext(RegistrationContext);

  const handleNext = async () => {
    if (!formData.email) {
      setError('Email is required.');
      return;
    }
    if (!isValidEmail(formData.email)) {
      setError('Please enter a valid email address.');
      return;
    }

    try {
      await sendVerificationCode(formData.email);
      setError('');
      setFormData((prevFormData) => ({
        ...prevFormData,
        contactEmail: prevFormData.email,
      }));
      setActiveStep((prevStep) => prevStep + 1);
    } catch (error) {
      console.error('Error sending verification code:', error);
      setError('User already exists');
    }
  };

  return (
    <Box>
      <Typography variant="body1" gutterBottom>
        This service will allow you to make GB Safety and Security declarations (known as ENS) to HMRC for Eurotunnel
        and Ferry arrivals (RORO) from the European Union to GB.
      </Typography>
      <Typography variant="body1" gutterBottom>
        The registering company is the person lodging the ENS declaration and as such, you must ensure you have the
        carrier’s “knowledge and consent” to submit the entry summary declaration on their behalf.
      </Typography>
      <Typography variant="body1" gutterBottom>
        You will be asked to provide information about your business to set up an account for commercial use. It is
        important that you are authorised to do this on behalf of your business or employer.
      </Typography>
      <ul>
        <li>Company Name</li>
        <li>GB EORI number</li>
        <li>Address</li>
        <li>Business contact details</li>
      </ul>
      <Typography variant="body1" gutterBottom>
        To register for this service, please enter your email address to receive a verification code.
      </Typography>
      <TextField
        fullWidth
        label="Email Address"
        variant="outlined"
        name="y-email"
        value={formData.email}
        onChange={handleChange}
        sx={{ my: 2 }}
        error={!!error}
        autoComplete="new-email"
        slotProps={{
          autoComplete: 'new-email',
          form: 'off',
        }}
        helperText={
          error ? (
            <Typography component="span" variant="caption" color="error">
              {Parser(error)}
            </Typography>
          ) : null
        }
      />
      <Button variant="contained" onClick={handleNext}>
        Continue
      </Button>
    </Box>
  );
};

export default BeforeYouStart;
